import React from 'react';

export const TitleWithWbr: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const titleWithBreaks = children
    ? children
        .toString()
        .split('/')
        .map((segment, index, array) => {
          return (
            <React.Fragment key={`${segment}_${index}`}>
              {segment}
              {index < array.length - 1 && (
                <React.Fragment>
                  /<wbr />
                </React.Fragment>
              )}
            </React.Fragment>
          );
        })
    : children;

  return titleWithBreaks;
};
